import { render } from "./UltraBtn.vue?vue&type=template&id=c742f664&scoped=true"
import script from "./UltraBtn.vue?vue&type=script&lang=js"
export * from "./UltraBtn.vue?vue&type=script&lang=js"

import "./UltraBtn.vue?vue&type=style&index=0&id=c742f664&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c742f664"]])

export default __exports__